import Icon from '@xo-union/tk-component-icons';
import React, { useContext, useEffect, useState } from 'react';

import { formatToAmPm } from '../helpers/formatTime';
import { ApiClientsContext, EventType } from './ApiClientsContext';
import DetailBox from './DetailBox';
import styles from './eventItem.scss';

interface Props {
  name?: string | null;
  venueName?: string | null;
  time?: string | null;
  type?: EventType;
  endTime?: string | null;
  showTime?: boolean;
  onClick: () => void;
}

export const EventItem: React.FC<Props> = ({ name, time, type, endTime, venueName, onClick, showTime = true }) => {
  const [missingInfo, setMissingInfo] = useState(false);
  const { eventType } = useContext(ApiClientsContext);

  useEffect(() => {
    if (eventType === 'WeddingDay' && type === 'WeddingEvent') {
      setMissingInfo(!name || !time);
    }
  }, [name, time, eventType, type]);

  return (
    <DetailBox shadow hasError={missingInfo}>
      <div
        tabIndex={0}
        role="button"
        className={`${styles.container}`}
        data-testid="event-item-container"
        onClick={onClick}
        onKeyDown={onClick}
      >
        <span className={styles.nameContainer}>
          <span className={styles.title}>{name}</span>
          <span>
            {showTime && (
              <span className={styles.time}>
                {time ? (
                  <span className={styles.subText}>{formatToAmPm(time)}</span>
                ) : (
                  <span className={`${styles.subText} ${styles.icon}`}>
                    + <span>Add Start Time</span>
                  </span>
                )}
                {endTime && <span className={styles.subText}>{` - ${formatToAmPm(endTime)}`}</span>}
              </span>
            )}
            {venueName ? (
              <span className={styles.subText}>{venueName}</span>
            ) : (
              <span className={`${styles.subText} ${styles.icon}`}>
                + <span>Add Location</span>
              </span>
            )}
          </span>
        </span>

        <Icon size="md" name="edit" className={styles.icon} />
      </div>
    </DetailBox>
  );
};
